import type { ConversationSearchResult } from "../types/conversation-attachments";
import { ConversationSearchPageSchema } from "../schemas/conversation-list";
import {
  usePaginatedConversations,
  type UsePaginatedConversationsResult,
} from "./use-paginated-conversations";

function parseSearchPage(data: unknown) {
  return ConversationSearchPageSchema.parse(data);
}

export function useAttachableConversations(
  query: string,
): UsePaginatedConversationsResult<ConversationSearchResult> {
  return usePaginatedConversations<ConversationSearchResult>({
    endpoint: "/api/chat/conversation/search",
    debouncedQuery: query,
    enabled: true,
    parsePage: parseSearchPage,
  });
}
